<nb-select
  #select
  id="{{key}}"
  [multiple]="multiple" placeholder="{{placeholder}}" 
  [disabled]="disabled" (selectedChange)="onChange($event)" [selected]="selectValue"
>
  <nb-option [value]="nullvalue"></nb-option>
  <nb-option *ngFor="let item of items" value="{{item.key}}"></nb-option>
</nb-select>
